export enum Ng4FilesStatus {
    STATUS_SUCCESS,
    STATUS_MAX_FILES_COUNT_EXCEED,
    STATUS_MAX_FILE_SIZE_EXCEED,
    STATUS_MAX_FILES_TOTAL_SIZE_EXCEED,
    STATUS_NOT_MATCH_EXTENSIONS
}

/**
 * Author: Noraini A.Ghani
 * 
 * Date Created: July 24th 2018
 * 
 * Description: File Upoad Configuration Interface
 **/
export interface Ng4FilesSelected {
  status: Ng4FilesStatus;
  files: File[];
}



// WEBPACK FOOTER //
// ./src/app/ng4-files/declarations/ng4-files-selected.ts